import { useLang } from '@/i18n';
import styles from './index.module.scss';
import EcoSpace from 'eco-design/base/eco-space';
import EcoTitle from 'eco-design/base/eco-title';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Scrollbar, Pagination } from 'swiper';
import EFPicture from '@elem/ui/ef-picture';

export default function Comp() {
    const { t } = useLang('dp3.page_v2.QuoteFromMedia');
    
    const lists = [
        {
            title: t('title1'),
            text: t('text1'),
        },
        {
            logo: 'https://websiteoss.ecoflow.com/upload/image/1744797224321/Digital%20Trends.png',
            text: t('text2'),
        },
        {
            logo: 'https://websiteoss.ecoflow.com/upload/image/1724133658862/USA%20Today%20(1).png',
            text: t('text3'),
        },
        {
            logo: 'https://websiteoss.ecoflow.com/upload/image/1724133658871/CNN%202.png',
            text: t('text4'),
        },
        {
            logo: 'https://websiteoss.ecoflow.com/upload/image/1724133658871/Good%20Housekeeping%20(1)%201.png',
            text: t('text5'),
        },
        {
            logo: 'https://websiteoss.ecoflow.com/upload/image/1724133658947/BobVila%201.png',
            text: t('text6'),
        },
    ];

    return (
        <div className={styles.thecomp} id="QuoteFromMedia">
            <EcoSpace />
            <EcoTitle title={t('title')} />
            <EcoSpaceSmall />
            <div className='swiper-wrapper'>
                <Swiper
                    className="quote-media-swiper-box"
                    modules={[Navigation, Scrollbar, Pagination]}
                    spaceBetween={0}
                    navigation
                    pagination={true}
                    loop={true}
                    scrollbar={{
                        hide: false,
                        draggable: true,
                    }}
                    slidesPerView={1}
                >
                    {lists.map((item, index) => (
                        <SwiperSlide key={index} className="quote-media-swiper-item">
                            {item.title && <p className="quote-media-card-title">{item.title}</p>}
                            {item.logo && <EFPicture className={`quote-media-card-logo logo-${index + 1}`} src={item.logo} />}
                            {item.text && <p className="quote-media-card-text">{item.text}</p>}
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}